<template>
  <div>
    <header-component />
    <service-category-banner-component />
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import serviceCategoryBannerComponent from './serviceCategoryBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'ServiceCategoryPage',
  components: {
    headerComponent,
    serviceCategoryBannerComponent,
    footerComponent,
  },
};
</script>
